import styles from "./paws.module.css";

/**
 * Six paw prints walking to the right, left and right in turn: shown while something is
 * being made ready. They are only faded and scaled, which the browser animates off the main
 * thread, so they keep stepping while the page is busy.
 */
export function Paws({ label }: { label?: string }) {
  return (
    <div class={styles.paws} role={label ? "status" : undefined} aria-label={label}>
      {[0, 1, 2, 3, 4, 5].map((k) => <span key={k} />)}
    </div>
  );
}
